import React, { useEffect, useState } from 'react';
import '../resources/Posts.css';

const Posts = () => {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [expandedPosts, setExpandedPosts] = useState(new Set());
  const [search, setSearch] = useState('');

  useEffect(() => {
    fetch('/posts.json')
      .then(res => {
        if (!res.ok) throw new Error('Failed to load posts data');
        return res.json();
      })
      .then(setPosts)
      .catch(err => setError(err.message))
      .finally(() => setLoading(false));
  }, []);

  const filteredPosts = posts.filter(
    post =>
      post.title.toLowerCase().includes(search.toLowerCase()) ||
      (post.summary && post.summary.toLowerCase().includes(search.toLowerCase())) ||
      (post.content && post.content.some(block =>
        (block.text && block.text.toLowerCase().includes(search.toLowerCase()))
      ))
  );

  const handleExpand = idx => {
    setExpandedPosts(prev => new Set(prev).add(idx));
  };

  const handleCollapse = idx => {
    setExpandedPosts(prev => {
      const next = new Set(prev);
      next.delete(idx);
      return next;
    });
  };

  if (loading) return <section className="posts-section"><p>Loading...</p></section>;
  if (error) return <section className="posts-section"><p>Error: {error}</p></section>;

  return (
    <section className="posts-section">
      <h2>Posts</h2>
      <input
        className="post-search"
        type="text"
        placeholder="Search posts..."
        value={search}
        onChange={e => setSearch(e.target.value)}
      />
      <div className="posts-list">
        {filteredPosts.length === 0 && <p>No posts found.</p>}
        {filteredPosts.map((post, idx) => {
          const isExpanded = expandedPosts.has(idx);
          const contentBlocks = post.content || [];
          const previewBlocks = isExpanded ? contentBlocks : contentBlocks.slice(0, 2);
          return (
            <div className="post-item" key={idx}>
              <h3>{post.title}</h3>
              {post.date && <span className="post-date">{post.date}</span>}
              <div className="post-content">
                {previewBlocks.map((block, bIdx) => {
                  if (block.type === 'paragraph') {
                    return <p key={bIdx}>{block.text}</p>;
                  } else if (block.type === 'image') {
                    // Always use absolute path for images in public/
                    let imgSrc = block.src;
                    if (imgSrc && !imgSrc.startsWith('http')) {
                      if (!imgSrc.startsWith('/')) {
                        imgSrc = '/' + imgSrc;
                      }
                    }
                    return <img key={bIdx} src={imgSrc} alt={block.alt || ''} style={{maxWidth: '100%', borderRadius: '12px', boxShadow: '0 2px 16px rgba(44,62,80,0.13)'}} />;
                  } else if (block.type === 'heading') {
                    return <h4 key={bIdx}>{block.text}</h4>;
                  } else if (block.type === 'subheading') {
                    return <h5 key={bIdx}>{block.text}</h5>;
                  } else if (block.type === 'code') {
                    return <pre key={bIdx}><code className={block.language || ''}>{block.text}</code></pre>;
                  } else if (block.type === 'table') {
                    return (
                      <div className="post-table-wrapper" key={bIdx}>
                        <table className="post-table">
                          <thead>
                            <tr>
                              {block.headers.map((header, hIdx) => <th key={hIdx}>{header}</th>)}
                            </tr>
                          </thead>
                          <tbody>
                            {block.rows.map((row, rIdx) => (
                              <tr key={rIdx}>
                                {row.map((cell, cIdx) => <td key={cIdx}>{cell}</td>)}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    );
                  } else {
                    return null;
                  }
                })}
              </div>
              {post.link && <a href={post.link} target="_blank" rel="noopener noreferrer">Read More</a>}
              {contentBlocks.length > 2 && !isExpanded && (
                <button className="modern-load-more-btn" onClick={() => handleExpand(idx)}>
                  <span className="modern-btn-label">Load More</span>
                </button>
              )}
              {isExpanded && contentBlocks.length > 2 && (
                <button className="modern-load-more-btn" onClick={() => handleCollapse(idx)}>
                  <span className="modern-btn-label">Show Less</span>
                </button>
              )}
            </div>
          );
        })}
      </div>
    </section>
  );
};

export default Posts;
